import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";
import thunk from "redux-thunk";

import agent from "./Apislices/agentsSlice";
import amenity from "./Apislices/amenitySlice";
import appliance from "./Apislices/applianceSlice";
import associate from "./Apislices/associate";
import auth, { fetchProfileData } from "./Apislices/authSlice";
import aws from "./Apislices/awsSlice";
import blogCategory from "./Apislices/blogCategoryslice";
import blogs from "./Apislices/blogSlice";
import city from "./Apislices/citySlice";
import community from "./Apislices/communitySlice";
import company from "./Apislices/companySlice";
import constructionMethod from "./Apislices/constructionMethodSlice";
import construction from "./Apislices/constructionSlice";
import country from "./Apislices/countrySlice";
import development from "./Apislices/developmentSlice";
import developmentType from "./Apislices/developmentTypeSlice";
import homeFacts from "./Apislices/homeFactsSlice";
import homeStyle from "./Apislices/homeStyleSlice";
import homeType from "./Apislices/homeTypeSlice";
import landTitle from "./Apislices/landTitleSlice";
import listing from "./Apislices/listingSlice";
import neighbourhood from "./Apislices/neighbourhoodSlice";
import parking from "./Apislices/parkingSlice";
import payment from "./Apislices/paymentSlice";
import project from "./Apislices/projectSlice";
import province from "./Apislices/provinceSlice";
import report from "./Apislices/reportSlice";
import review from "./Apislices/reviewSlice";
import saleStatus from "./Apislices/saleStatusSlice";
import settings from "./Apislices/settings";
import tags from "./Apislices/tagsSlice";
import testimony from "./Apislices/TestimonySlice";
import unitFeatures from "./Apislices/unitFeaturesSlice";
import unitPreference from "./Apislices/unitPreferenceSlice";
import user from "./Apislices/userSlice";
import garageLayout from "./Apislices/garageLayoutSlice";
import homepage from "./Apislices/homepageSlice";

const reducers = combineReducers({
  auth,
  user,
  development,
  listing,
  amenity,
  city,
  country,
  homeFacts,
  homeStyle,
  homeType,
  landTitle,
  neighbourhood,
  parking,
  province,
  saleStatus,
  unitFeatures,
  unitPreference,
  construction,
  developmentType,
  constructionMethod,
  agent,
  company,
  community,
  aws,
  project,
  settings,
  blogs,
  tags,
  blogCategory,
  payment,
  review,
  testimony,
  associate,
  report,
  appliance,
  garageLayout,
  homepage,
});

const persistConfig = {
  key: "root_persist",
  storage: sessionStorage,
  blacklist: ["report", "homepage", "blogs"], // Exclude the report slice from being persisted
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  // middleware: [thunk],
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: true }),
});

const initializeApp = async () => {
  await store.dispatch(fetchProfileData());
};

initializeApp();

export const persistor = persistStore(store);
